import { useState } from 'react';
import { ClbButton, ClbTooltip } from '@celebration/react';
import WonOfferDetails from '../won-offer-details/won-offer-details';
import i18n from '../../../../../lib/i18n';
import './won-offer-action-buttons.scss';
import { IWonOfferActionButtonsProps } from './IWonOfferActionButtonsProps';

export default function WonOfferActionButtons({
    offer,
    refreshItem,
}: Readonly<IWonOfferActionButtonsProps>) {
    const [detailOpen, setDetailOpen] = useState<boolean>(false);

    return (
        <>
            <div className="won-offer-action-buttons">
                <ClbTooltip
                    description={i18n.t('Info')}
                    position="top"
                    showArrow
                    colorMode="dark"
                >
                    <ClbButton
                        icon="info"
                        size="md"
                        styleType="icon"
                        data-testid="won-offer-details-button"
                        onClick={() => setDetailOpen(true)}
                    />
                </ClbTooltip>
                <ClbTooltip
                    description={i18n.t('Recarregar')}
                    position="top"
                    showArrow
                    colorMode="dark"
                >
                    <ClbButton
                        icon="refresh"
                        size="md"
                        styleType="icon"
                        data-testid="won-offer-refresh-button"
                        onClick={() => refreshItem()}
                    />
                </ClbTooltip>
            </div>

            {detailOpen && (
                <WonOfferDetails
                    setOpen={setDetailOpen}
                    wonOfferLoad={offer.load}
                />
            )}
        </>
    );
}
